class Rf {
  constructor() {
    this.init = false
    this._player = "rf"
    this._satellites = ["TURKSAT_42E", "HOTBIRD_13E", "ASTRA_19_2E"]
    this._polarization = { H: "POL_HL", V: "POL_VL" }
  }
  _init = async () => {
    await new Promise(resolve => {
      const check = () => {
        if (typeof tizen !== "undefined" && typeof webapis !== "undefined") resolve()
        else setTimeout(check, 100)
      }
      check()
    })
    tizen.tvchannel.addSignalStateChangeListener(state => state === "SIGNAL_STATE_OK" && _$.handler.emit("media_event", "play"))
    return true
  }

  start = async () => {
    return true
  }
  destroy = async () => {
    return this.stop()
  }
  play = async () => {
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    promise.terminateAfter(8000)
    this.closeSubtitle()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      const params = __.media._convertDVB(__.media.source)
      const dvb = {}
      switch (params.broadcastType) {
        case "DVBC":
          dvb.broadcastStandard = "DVB"
          dvb.channelType = "CDTV"
          dvb.frequency = parseFloat(params.frequency) * 1000
          dvb.programNumber = parseInt(params.programNumber)
          dvb.modulationType = "QAM256"
          dvb.bandwidth = "8MHz"
          dvb.symbolRate = parseInt(params.symbolRate)
          dvb.major = 2
          break
        case "DVBT":
          dvb.broadcastStandard = "DVB"
          dvb.channelType = "DTV"
          dvb.frequency = parseFloat(params.frequency) * 1000
          dvb.modulationType = "QAM256"
          dvb.bandwidth = "8Mhz"
          dvb.programNumber = parseInt(params.programNumber)
          dvb.major = 2
          break
        case "DVBT2":
          dvb.broadcastStandard = "DVB"
          dvb.channelType = "DTV"
          dvb.frequency = parseFloat(params.frequency) * 1000
          dvb.modulationType = "OFDM_T2"
          dvb.bandwidth = "8Mhz"
          dvb.programNumber = parseInt(params.programNumber)
          dvb.major = 2
          break
        case "DVBS":
          dvb.broadcastStandard = "DVB"
          dvb.channelType = "SDTV"
          dvb.frequency = parseFloat(params.frequency) * 1000
          dvb.modulationType = "QPSK"
          dvb.bandwidth = "8Mhz"
          dvb.symbolRate = parseInt(params.symbolRate)
          dvb.satelliteId = this._satellites[parseInt(params.satelliteID) - 1]
          dvb.programNumber = parseInt(params.programNumber)
          dvb.polarization = this._polarization[params.polarization] || "POL_VL"
          break
        case "ANALOG":
          dvb.broadcastStandard = "DVB"
          dvb.channelType = "ATV"
          dvb.frequency = parseFloat(params.frequency)
          dvb.modulationType = "PAL"
          dvb.soundSystem = "AUTO"
          dvb.colorsSystem = "AUTO"
          break
      }
      __._event._setVideoSize()
      webapis.broadcast.tuneDirect(
        dvb,
        () => {},
        () => _$.handler.emit("media_event", "play")
      )
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  stop = async () => {
    let promise = await _$.progress.create(_$.progress.type.STOP)

    _$.vue.$once(["mediaStopped", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    try {
      tizen.tvwindow.hide(() => _$.handler.emit("media_event", "stop"), null, "MAIN")
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
  pause = async () => {
    return true
  }
  continue = async () => {
    return true
  }

  /* Control Helpers */
  isSeekable = async () => {
    return false
  }
  getDuration = async () => {
    return 0
  }
  getPosition = async () => {
    return 0
  }
  setPosition = async () => {
    return false
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    try {
      /* Library Code */
      let subtitles = webapis.broadcast.getTotalSubtitleInfo().filter((value, index, self) => {
          return self.findIndex(v => v.language === value.language) === index && value.language !== "yyy"
        }),
        hasCurrent = webapis.broadcast.getCurrentSubtitle()
      /* Library Code */

      subtitles = subtitles.map(subtitle => {
        return { key: subtitle.index.toString(), value: subtitle.language, selected: subtitle.index === hasCurrent.index }
      })

      if (!subtitles.length) return false
      else subtitles.unshift({ key: "off", value: "None", selected: !hasCurrent.index })

      return subtitles
    } catch (error) {
      return false
    }
  }
  setSubtitle = async pid => {
    if (pid === "off" || pid === -1) {
      webapis.tvinfo.setMenuValue(webapis.tvinfo.TvInfoMenuKey.SUBTITLE_ONOFF_KEY, webapis.tvinfo.TvInfoMenuValue.OFF, () => {})
      return true
    }

    webapis.broadcast.setCurrentSubtitleIndex(parseInt(pid), () => {})
    webapis.tvinfo.setMenuValue(webapis.tvinfo.TvInfoMenuKey.SUBTITLE_ONOFF_KEY, webapis.tvinfo.TvInfoMenuValue.ON, () => {})
    return true
  }
  closeSubtitle = async () => {
    return this.setSubtitle(-1)
  }

  getLanguages = async () => {
    try {
      /* Library Code */
      let audios = webapis.broadcast.getTotalAudioInfo().filter((value, index, self) => {
          return self.findIndex(v => v.language === value.language) === index && value.language !== "yyy"
        }),
        hasCurrent = webapis.broadcast.getCurrentAudioInfo()
      /* Library Code */

      audios = audios.map(audio => {
        return { key: audio.index.toString(), value: audio.language, selected: audio.index === hasCurrent.index }
      })

      if (!audios.length) return false
      else return audios
    } catch (error) {
      return false
    }
  }
  setLanguage = async pid => {
    webapis.broadcast.setCurrentAudio(
      parseInt(pid),
      () => {},
      () => {}
    )
    return true
  }
}

export default Rf
